import { Building2, MapPin, Landmark, Zap } from "lucide-react";
import type { JurisdictionLevel } from "@/data/onboardingData";

const CONFIG: Record<JurisdictionLevel, { icon: React.ElementType; label: string; color: string; bg: string }> = {
  city:    { icon: Building2,   label: "City",    color: "text-primary",                    bg: "bg-primary/10" },
  county:  { icon: MapPin,      label: "County",  color: "text-[hsl(175,70%,40%)]",         bg: "bg-[hsl(175,70%,40%)]/10" },
  state:   { icon: Landmark,    label: "State",   color: "text-[hsl(280,70%,50%)]",         bg: "bg-[hsl(280,70%,50%)]/10" },
  utility: { icon: Zap,         label: "Utility", color: "text-[hsl(38,92%,50%)]",          bg: "bg-[hsl(38,92%,50%)]/10" },
};

interface JurisdictionBadgeProps {
  level: JurisdictionLevel;
  showLabel?: boolean;
}

export function JurisdictionBadge({ level, showLabel = false }: JurisdictionBadgeProps) {
  const c = CONFIG[level];
  const Icon = c.icon;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-1.5 py-0.5 text-xs font-medium ${c.color} ${c.bg}`}>
      <Icon className="h-3 w-3" />
      {showLabel && <span>{c.label}</span>}
    </span>
  );
}
